
export const text = `

This has been the QuotableQuotidian! Thank you so much for watching all the way to the end! Like and subcribe if you found this video helpful! If I am replaced on subsequent watchthroughs it is already too late. I will join my children. You will join my children.
`